module.exports = __webpack_public_path__ + "static/media/logo.a70552d3.svg";